import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Nav from "@/components/marketing/Nav";
import Footer from "@/components/marketing/Footer";
import { Reveal } from "@/components/Reveal";
import api from "@/lib/api";

export default function Destinations() {
  const [corridors, setCorridors] = useState([]);
  useEffect(() => { api.get("/corridors").then((r) => setCorridors(r.data)).catch(() => {}); }, []);
  return (
    <div className="min-h-screen bg-softcream">
      <Nav />
      <section className="mx-auto max-w-page px-5 py-16 sm:px-8 sm:py-20 md:py-28 lg:px-12">
        <Reveal>
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.2em] text-coral sm:text-base">Supported corridors</p>
          <h1 className="max-w-3xl font-serif text-4xl leading-tight tracking-tight text-heading sm:text-5xl md:text-6xl">Choose where your journey begins.</h1>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted sm:text-lg">We start with a small set of high-friction corridors and expand only when each one is validated. Availability is shown honestly. We never claim live government integration.</p>
        </Reveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {corridors.map((c, i) => (
            <Reveal key={c.key} delay={(i % 3) * 0.08}>
              <Link to={`/destinations/${c.key}`} data-testid={`destination-${c.key}`}
                className="group block overflow-hidden rounded-md border border-hborder bg-white transition-all duration-300 ">
                <div className="relative h-48 overflow-hidden">
                  <img src={c.image_url} alt={c.destination} className="h-full w-full object-cover transition-transform duration-700 " loading="lazy" />
                </div>
                <div className="p-5">
                  <p className="text-xl font-semibold text-heading">{c.destination}</p>
                  <p className="mt-1.5 text-[15px] leading-relaxed text-muted">{c.summary}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-tblue">
                    View requirements <ArrowRight size={15} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
